module.exports = __webpack_public_path__ + "static/media/135U3_Kitchen.c858668f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U3_Kitchen.jpg
// module id = 541
// module chunks = 0